import { render } from "./WidgetsComponent.vue?vue&type=template&id=1e959748&scoped=true"
import script from "./WidgetsComponent.vue?vue&type=script&lang=js"
export * from "./WidgetsComponent.vue?vue&type=script&lang=js"

import "./WidgetsComponent.vue?vue&type=style&index=0&id=1e959748&lang=scss&scoped=true"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e959748"]])

export default __exports__